"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.display = void 0;

var _styledComponents = require("styled-components");

var _Theme = require("./Theme.media");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["display: ", ";"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["display: ", ";"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["display: ", ";"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["display: ", ";"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["display: ", ";"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var display = function display(props) {
  return (0, _styledComponents.css)(_templateObject(), function (props) {
    return props.display;
  }, props.displayXs && _Theme.media.xs(_templateObject2(), props.displayXs), props.displaySm && _Theme.media.sm(_templateObject3(), props.displaySm), props.displayMd && _Theme.media.md(_templateObject4(), props.displayMd), props.displayLg && _Theme.media.lg(_templateObject5(), props.displayLg), props.displayXl && _Theme.media.xl(_templateObject6(), props.displayXl));
};

exports.display = display;